<div class="field" *ngIf="searchField">
  <span class="p-float-label">
    <p-autoComplete
      [inputStyleClass]="'input-filters'"
      [type]="inputType"
      id="autocomplete"
      [suggestions]="filteredEntities"
      [dropdown]="showDropDown"
      [formControl]="control"
      [field]="displayWithEntityFn"
      [showEmptyMessage]="true"
      [showClear]="true"
      (onClear)="clearSelectValue()"
      [emptyMessage]="'Nenhum resultado encontrado!'"
      [readonly]="readonly"
    >
      <ng-template pTemplate="item" let-entity>
        {{ displayWithEntityFn(entity) }}
      </ng-template>
      <ng-template pTemplate="footer">
        <button
          pButton
          pRipple
          *ngIf="!isLoading && insertType && actionState"
          label="Adicionar agora"
          icon="pi pi-plus"
          iconPos="right"
          (click)="
            openDialogAddEntity ? openDialogAddEntity() : openDialogFast()
          "
          class="p-button-text p-button-outlined p-button-primary width-100"
        ></button>
      </ng-template>
    </p-autoComplete>
    <label for="autocomplete">{{ placeholder }}</label>
  </span>
</div>
<div *ngIf="!searchField">
  <mat-form-field
    class="w-100"
    (click)="inputFastAuto.select()"
    appearance="outline"
  >
    <mat-label (click)="inputFastAuto.select()">
      {{ placeholder }}
    </mat-label>
    <input
      #inputFastAuto
      matInput
      (click)="inputFastAuto.select()"
      [formControl]="control"
      [matAutocomplete]="auto"
      [type]="inputType"
      (keydown)="
        useOnlyNumbers || inputType === 'number'
          ? validateOnlyNumbers($event)
          : null
      "
      (click)="notShowOptions = false"
      (blur)="blur.emit($event)"
      [readonly]="readonly"
      name="fast-autcomplete"
      autocomplete="off"
    />
    <button
      *ngIf="showBtnDialog"
      mat-icon-button
      matSuffix
      (click)="dialogClick()"
    >
      <mat-icon color="primary">{{ btnIcon }}</mat-icon>
    </button>
    <button
      *ngIf="controlIsEnable && !readonly"
      mat-icon-button
      matSuffix
      (click)="control.value ? clearSelectValue() : null"
    >
      <i
        *ngIf="control.value"
        class="pi pi-times-circle mb-1"
        style="color: red"
      ></i>
      <i
        *ngIf="!control.value"
        class="pi pi-angle-down mb-1"
        style="color: 'var(--primary-color)'"
      ></i>
    </button>
    <button
      *ngIf="!controlIsEnable && !readonly && showDropdownIcon"
      mat-icon-button
      matSuffix
    >
      <i
        class="pi pi-angle-down mb-1"
        style="color: 'var(--primary-color)'"
      ></i>
    </button>
  </mat-form-field>
  <small class="p-error" *ngIf="control.invalid && control.touched">
    {{ messages[getKey()] }}
  </small>
</div>
<mat-autocomplete
  (blur)="blur.emit($event)"
  autoActiveFirstOption
  #auto="matAutocomplete"
  [displayWith]="displayWithEntityFn"
>
  <mat-option
    disabled
    *ngIf="forcedNotShowOptions ? isLoading && !notShowOptions : isLoading"
    class="is-loading"
  >
    <div
      class="flex justify-content-center align-items-center width-100"
      [style]="{ width: '50px', height: '50px' }"
    >
      <p-progressSpinner></p-progressSpinner>
    </div>
  </mat-option>

  <!-- <mat-option disabled *ngIf="noResults && control.value && !isLoading && !control.hasError('isEmptyValue')">
    Não encontramos nada com {{ control.value }}
  </mat-option> -->
  <mat-option
    disabled
    *ngIf="
      filteredEntities.length === 0 &&
      !control.hasError('isEmptyValue') &&
      !isLoading
    "
  >
    Não existe nenhum disponível!
  </mat-option>
  <ng-container *ngIf="!isLoading && !notShowOptions">
    <mat-option
      (onSelectionChange)="onSelect.emit(entity)"
      *ngFor="let entity of filteredEntities"
      [value]="entity"
    >
      {{ displayWithEntityFn(entity) }}
    </mat-option>
    <mat-option
      *ngIf="
        !isLoading &&
        insertType &&
        actionState &&
        !control.hasError('isEmptyValue')
      "
      (click)="openDialogAddEntity ? openDialogAddEntity() : openDialogFast()"
    >
      <div class="flex align-items-center text-black-alpha-80">
        <i class="mdi mdi-plus"></i>
        Adicionar agora
      </div>
    </mat-option>
  </ng-container>
</mat-autocomplete>
